(() => {
  // The Constructor app only uses its column settings for the loading
  // placeholder; the product grid it renders has fixed classes. Expose the
  // settings as CSS variables so template-collection.css can size the grid.
  // Without the app (or with a bad value) the CSS falls back to the design:
  // 3 columns on desktop and 2 on mobile. Tablet stays at 3.
  const settings = window.LeviPlpConfig && window.LeviPlpConfig.settings;
  if (!settings) return;

  const columns = (value, max) => {
    const count = parseInt(value, 10);
    return count >= 1 && count <= max ? count : null;
  };

  const desktop = columns(settings.desktop_product_grid_column, 6);
  const mobile = columns(settings.mobile_product_grid_column, 3);
  const root = document.documentElement.style;

  if (desktop) root.setProperty('--plp-cols-desktop', desktop);
  if (mobile) root.setProperty('--plp-cols-mobile', mobile);
})();
